import {
  Autocomplete,
  Box,
  FormControl,
  FormLabel,
  Input,
  Table,
  Textarea,
  TextField,
  Typography
} from '@mui/joy';

import React, { useEffect, useState } from 'react';

function FragenBeantworter({ data, afrage, setfragen, bewertung, setbewertung }) {
  function set(f, v) {
    const newMap = new Map(afrage);
    newMap.set(f, v);
    setfragen(newMap);
  }

  function get(f) {
    return afrage.get(f) ?? "";
  }

  function setb(f, v) {
    const map = new Map(bewertung);
    map.set(f, v);
    setbewertung(map);
  }

  function getbewertung(f) {
    return bewertung.get(f) ?? null;
  }

  const [load, setload] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setload(true), 250);
    return () => clearTimeout(timeout);
  }, []);

  if (!load) return <>Loading</>;

  return (
    <>
      {data.fragen &&
        data.fragen
          .slice()
          .sort((a, b) => a.order - b.order)
          .map((item, index) => {
            const keys = Object.keys(item).filter(k => k !== "order");
            const name = keys[0] || "Unbenannt";
            return (
              <Box key={index} sx={{ mb: 4 }}>
                <Typography level="h6" component="div">{name}</Typography>
                <Table sx={{ '& thead th:nth-child(1)': { width: '45%' }, mt: 1 }}>
                  <thead>
                    <tr>
                      <th>Frage</th>
                      <th>Antwort</th>
                      <th>Bewertung</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item[name]
                      .slice()
                      .sort((a, b) => a.order - b.order)
                      .map((frage, idx) => (
                        <tr key={idx}>
                          <td>{frage.name}</td>
                          <td>
                            <FormControl>
                              <Textarea
                                minRows={2}
                                maxRows={4}
                                value={get(frage.name)}
                                placeholder="Bitte tragen Sie die fragenbezogenen Daten ein..."
                                variant="outlined"
                                onChange={(e) => set(frage.name, e.target.value)}
                              />
                            </FormControl>
                          </td>
                          <td>
                            <Autocomplete
                              value={getbewertung(frage.name)}
                              onChange={(e, newval) => setb(frage.name, newval)}
                              placeholder="Bitte wählen"
                              options={frage.bewertung}
                              getOptionLabel={(item) => item?.bzh ?? ""}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Box>
            );
          })}
    </>
  );
}

export default FragenBeantworter;
